<form [name]="form" [formGroup]="form">
    <div class="mb-24" fxLayout="column" fxLayoutAlign="start">
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="stretch"
             fxLayoutAlign.sm="stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
                <mat-label>Tipo Organización</mat-label>
                <input matInput formControlName="tipoOrganizacion" [matAutocomplete]="autoTipoOrganizacion"
                       [required]="form.get('tipoOrganizacion').errors !== null && form.get('tipoOrganizacion').errors.required">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoTipoOrganizacion="matAutocomplete" [displayWith]="displayFn"
                                (optionSelected)="onTipoOrganizacionSelected($event)" notWhitespacesValid>
                    <mat-option *ngFor="let option of tipoOrganizacionFilter$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="stretch"
             fxLayoutAlign.sm="stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
                <mat-label>Unidad organizacional receptora</mat-label>
                <input matInput formControlName="organizacion" [matAutocomplete]="autoUnidadDerivar"
                       [required]="form.get('organizacion').errors !== null && form.get('organizacion').errors.required">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoUnidadDerivar="matAutocomplete" [displayWith]="displayFn"
                                  (optionSelected)="onUnidadSelected($event)" notWhitespacesValid>
                    <mat-option *ngFor="let option of unidadFilter$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div *ngIf="asignarResponsable"fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="stretch"
             fxLayoutAlign.sm="stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
                <mat-label>Usuario receptor</mat-label>
                <input matInput formControlName="usuarioAsignado" [matAutocomplete]="autoUsuarioDerivar"
                       [required]="form.get('usuarioAsignado').errors !== null && form.get('usuarioAsignado').errors.required">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoUsuarioDerivar="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of usuarioFilter$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>

            </mat-form-field>
        </div>
    </div>
</form>
